import Homepage from "./pages/homepage";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./styles/sty.css"

function App() {
  return (
    <>
    <Homepage/>
    
    </>
  )
  
  
}

export default App;
